var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-start px-2 space-x-2 text-base-90 whitespace-nowrap",class:{
    'hover:bg-base-10 cursor-pointer': _vm.clickable,
    'text-xs leading-6': _vm.size === 'sm',
    'leading-9': _vm.size === 'md',
  },on:{"click":_vm.handleItemClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }